module.exports = __webpack_public_path__ + "img/main-list_02.e7619651.jpg";